/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDYourSettings' store object.
 * @namespace SDYourSettingsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDYourSettings';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdGetExternalUserSettings = state =>
    state[selectors.moduleIdentifier].postSdGetExternalUserSettings.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static isFetchingPostSdGetExternalUserSettings = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdGetExternalUserSettings.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdGetExternalUserSettingsError = state =>
    state[selectors.moduleIdentifier].postSdGetExternalUserSettingsError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdSetExternalUserSettings = state =>
    state[selectors.moduleIdentifier].postSdSetExternalUserSettings.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static isFetchingPostSdSetExternalUserSettings = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdSetExternalUserSettings.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdSetExternalUserSettingsError = state =>
    state[selectors.moduleIdentifier].postSdSetExternalUserSettingsError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static getCodetablesByTableName = state =>
    state[selectors.moduleIdentifier].getCodetablesByTableName.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static isFetchingGetCodetablesByTableName = state =>
    state[selectors.moduleIdentifier].isFetchingGetCodetablesByTableName.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static getCodetablesByTableNameError = state =>
    state[selectors.moduleIdentifier].getCodetablesByTableNameError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static getSdUserEmailLinkedToOtherAccountByEmailAddress = state =>
    state[selectors.moduleIdentifier].getSdUserEmailLinkedToOtherAccountByEmailAddress.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static isFetchingGetSdUserEmailLinkedToOtherAccountByEmailAddress = state =>
    state[selectors.moduleIdentifier].isFetchingGetSdUserEmailLinkedToOtherAccountByEmailAddress
      .payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static getSdUserEmailLinkedToOtherAccountByEmailAddressError = state =>
    state[selectors.moduleIdentifier].getSdUserEmailLinkedToOtherAccountByEmailAddressError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdSendVerificationCode = state =>
    state[selectors.moduleIdentifier].postSdSendVerificationCode.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static isFetchingPostSdSendVerificationCode = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdSendVerificationCode.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdSendVerificationCodeError = state =>
    state[selectors.moduleIdentifier].postSdSendVerificationCodeError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdVerifySubmittedCode = state =>
    state[selectors.moduleIdentifier].postSdVerifySubmittedCode.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static isFetchingPostSdVerifySubmittedCode = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdVerifySubmittedCode.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDYourSettingsSelectors
   */
  static postSdVerifySubmittedCodeError = state =>
    state[selectors.moduleIdentifier].postSdVerifySubmittedCodeError.payload;
}
